import { type Cadence } from "~/types";

type Props = {
  cadences: Cadence[];
  onSelect: (cadence: Cadence) => void;
  selectedCadence: Cadence;
};

export const CadenceOptions = ({
  cadences,
  onSelect,
  selectedCadence,
}: Props) => (
  <ul className="menu rounded-box active menu-horizontal menu-sm bg-base-200">
    {cadences.map((c) => (
      <li key={c.id} onClick={() => onSelect(c)}>
        <a
          className={c.id === selectedCadence.id ? " nderline" : "no-underline"}
        >
          {c.name}
        </a>
      </li>
    ))}
  </ul>
);
